<template>
  <div class="km__modules__pattern">
    <PatternCategorySelection :currentPatternCategory="currentPatternCategory"
                              @setCurrentPatternCategory="setCurrentPatternCategory"
                              :currentColorCode="currentColorCode"/>
    <PatternSelection
        :currentPatternCategory="currentPatternCategory"
        :currentPattern="currentPattern"
        @setCurrentPattern="setCurrentPattern"
    />
  </div>
</template>

<script lang="ts" setup>
import {computed, Ref, ref} from "vue";
import PatternCategorySelection from "@km/components/patternselection/PatternCategorySelection.vue";
import PatternSelection from "@km/components/patternselection/PatternSelection.vue";
import {useStore} from "vuex";
import {COLORMODULE_POSSIBLE_STATES} from "@km/components/color/ModuleColorAnimationStates";
import {PatternFactory, PATTERN_EVENTNAMES} from "@k/js/pattern/patternFactory";
import {StockLogoPoolEntry} from "@k/js/stocklogos/stocklogoController";
import {EventListener, EventVerteiler} from "@k/global/eventVerteiler"
import {resourcemanagerVue} from "@km/js/resourceManagerVue";
import {useColoreditStore} from "@km/components/color/colorEditStatusStore";
import {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";

const statusStore = useColoreditStore();
const currentColorCode = computed(()=>statusStore.getCurrentColorCode);

const store = useStore();
const openStatusStore = useModuleColorOpenStateStore();
const currentPatternCategory = ref({});
const currentPattern = ref(null) as Ref<StockLogoPoolEntry | null>;

function setCurrentPatternCategory(obj) {
  currentPatternCategory.value = obj;
}

const e = new EventListener();
e.addEventListener(PATTERN_EVENTNAMES.DELETED, ({colorCodeNr}) => {
  if (colorCodeNr === store.getters.getColorCodeNr(currentColorCode.value)) {
    currentPatternCategory.value = {};
    currentPattern.value = null;
  }
})

function createPattern(stockLogoID) {
  const colorCodeNr = store.getters.getColorCodeNr(currentColorCode.value);
  const pattern = store.getters["StockLogoStore/getLogo"](stockLogoID);
  PatternFactory.createPattern(pattern.stockLogoID, pattern.colors, colorCodeNr, pattern.standardSizeCM);
  resourcemanagerVue.createTask("selectPatternForEdit").discardAfterExecution()
      .when("patterncreatedFor" + colorCodeNr, "done").thenDo(() => {
    EventVerteiler.broadcast(PATTERN_EVENTNAMES.SELECTED, store.getters.getPattern(currentColorCode.value))
  })
}

function setCurrentPattern(obj: StockLogoPoolEntry) {
  currentPattern.value = obj;
  openStatusStore.setCurrentState(COLORMODULE_POSSIBLE_STATES.patterncolors);
  createPattern(obj.stockLogoID)
}
</script>

<style lang="scss" scoped>
/* ***********************************
*	MODULE PATTERN
* -
* ********************************** */

</style>
